
import Vue from 'vue';
import ReferenceService from '@/services/ReferenceService';
import { extractErrorMessage } from '@/utils/Util';

export default Vue.extend({
  name: 'ReferenceDeleteDialog',
  props: {
    row: { type: Object, required: true },
    tenantId: { type: String, required: false },
  },
  data: () => ({
    localDialog: false,
    alertText: '',
    alertVisible: false,
    alertType: 'error',
    loading: false,
  }),

  methods: {
    close() {
      this.localDialog = false;
    },
    clear() {
      this.alertVisible = false;
      this.loading = false;
    },
    dismiss() {
      this.clear();
      this.close();
    },
    async confirmDelete() {
      if (!this.row?.uuid || !this.row?.templateId) {
        this.alertType = 'error';
        this.alertText = (this.$t('error') as string) || 'Error';
        this.alertVisible = true;
        return;
      }

      this.loading = true;
      try {
        await ReferenceService.deleteData(
          this.currentTenant,
          this.row.templateId,
          this.row.uuid
        );

        this.alertType = 'success';
        this.alertText = this.$t('reference.successDelete') as string;
        this.alertVisible = true;
        this.loading = false;

        setTimeout(() => {
          this.$emit('delete', this.row);
          this.dismiss();
        }, 2000);
      } catch (err: any) {
        console.log(err, err?.response);
        this.alertType = 'error';
        this.alertText =
          (this.$t('reference.errorDelete') as string) +
          ' ' +
          extractErrorMessage(err);
        this.alertVisible = true;
        this.loading = false;
      }
    },
  },
  computed: {
    currentTenant(): string {
      return (
        (this.tenantId as string) ||
        this.$root.$store.state.session.selectedTenant.uuid
      );
    },
  },
});
